// In-memory (not persisted) cache of the in-progress SubmitDispute form, so
// navigating to /checkout/:uuid and back doesn't lose what was typed. Plain
// module-scoped state survives an SPA route unmount/remount but not a full
// page reload — that's fine here since a reload also drops the unsaved File
// evidence objects, which can't be serialized anyway.
let cachedDraft = null;

export function saveDraft(draft) {
  cachedDraft = draft;
}

export function getDraft() {
  return cachedDraft;
}

export function clearDraft() {
  cachedDraft = null;
}
